import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import './style.scss';
import { alpha, Stack, Typography, useTheme } from '@mui/material';
export function UserMessage({ content, timestamp }) {
    const theme = useTheme();
    return (_jsx(Stack, { flexDirection: 'row', gap: 4, sx: { width: '100%' }, children: _jsxs(Stack, { sx: {
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
                color: theme.palette.primary.main,
                padding: '10px 16px',
                borderRadius: '16px 16px 0px 16px',
                maxWidth: '80%',
                gap: '7px',
                marginLeft: 'auto'
            }, children: [_jsxs(Typography, { variant: 'body1', color: theme.palette.text.primary, textAlign: 'left', children: [' ', _jsx(ReactMarkdown, { className: 'reactMarkDown', remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw], children: content })] }), _jsx(Typography, { variant: 'caption', color: theme.palette.primary.main, textAlign: 'left', children: timestamp })] }) }));
}
